export default __webpack_public_path__ + "static/media/fireControl-show2.aa97782e.png";